import React from "react";

function DeleteButton({ handleDelete }) {
  return (
    <button
      onClick={handleDelete}
      className="bg-red-100 font-semibold text-slate-500 h-5 w-5 flex items-center justify-center transition hover:text-slate-900 hover:bg-red-300 rounded-sm text-xs"
    >
      x
    </button>
  );
}

export default DeleteButton;
